import React from 'react';
import GenericRecordItemTemplate from '../Generics/GenericRecordItemTemplate';
import { type ItemTemplateParams } from '@aha-app/selectro-v2';

const StrategicImperativeItemTemplate: React.FC<ItemTemplateParams> = props => {
  const buildDetails = () => {
    if (props.item.branch) {
      return [props.item.data.suffix] as string[];
    }
    return [
      props.item.data.reference_num,
      props.item.data.time_frame,
    ] as string[];
  };
  return (
    <GenericRecordItemTemplate {...props} bottomDetails={buildDetails()} />
  );
};

export default StrategicImperativeItemTemplate;
